import { Colors, Services } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import sticker from '@/components/sticker'

export default function(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.port,
        icon: icons.vpn_lock,
        color: Colors.grey,
        label: this.getTranslate(`${Services.servers}.labels.port`)
      }
    }
  )
}
